import { useEffect } from "react";

type TitlePart = string | null | undefined | false;

export function buildTitle(...parts: TitlePart[]): string {
  const segments = parts
    .map((part) => (typeof part === "string" ? part.trim() : ""))
    .filter((part) => part.length > 0);

  return [...segments, "Light Dashboard"].join(" | ");
}

/**
 * Sets `document.title` for the lifetime of the calling component. Accepts
 * multiple string arguments, in order of descending specificity. Falsy values
 * are ignored, so you can call with optional undefineds.
 */
export function useDocumentTitle(...parts: TitlePart[]): void {
  const title = buildTitle(...parts);

  useEffect(() => {
    document.title = title;
  }, [title]);
}
